import { Injectable } from '@angular/core';

/**
 * Ermöglicht das Setzen des Seitentitels aus einer Portalkomponente heraus.
 */
@Injectable()
export abstract class IPortalPageTitleService {

    /**
     * Setzt einen Page-Titel, der vom konfigurierten Namen der Seite abweicht.
     * Der Titel gilt bis maximal zum nächsten Seitenwechsel.
     *
     * @param pageTitle der gewünschte Titel
     */
    public setCustomPageTitle(pageTitle: string) {
        // mit Absicht leer
    }

    /**
     * Setzt den Page-Titel auf den konfigurierten Namen der Seite zurück
     */
    public resetPageTitle() {
        // mit Absicht leer
    }
}
